export const PRODUCT_SWATCH_SET_SKU = 'BEAMLY/CCX/PRODUCT_SWATCH_SET_SKU';
export const TOGGLE_ALL_SHADES = 'BEAMLY/CCX/TOGGLE_ALL_SHADES';

export const setProductSKU = sku => ({
  type: PRODUCT_SWATCH_SET_SKU,
  selectedSKU: sku,
});

export const toggleAllShades = () => ({
  type: TOGGLE_ALL_SHADES,
});
